import { useMutation, useQueryClient } from "react-query";
import { createAction } from "client-api-workflow";

export interface CreateActionParams {
	actionName: string;
	description: string;
	assignTo: string[];
	assignToNames: string[];
	searchKpiInitiativeId?: string | null;
	searchKpiInitiativeName?: string | null;
	searchKpiInitiativeType?: string | null;
	status: string;
	createdBy?: string;
	tenantId?: string;
}

const useCreateAction = () => {
	const queryClient = useQueryClient();

	return useMutation(
		async (data: CreateActionParams) => {
			const result = await createAction(data);
			return result;
		},
		{
			onSuccess: () => {
				// Invalidate the actions queries including filtered ones
				queryClient.invalidateQueries({ queryKey: "actions" });
				queryClient.invalidateQueries({ queryKey: ["actionsByKpiInitiative"] });
			},
		}
	);
};

export default useCreateAction;

